import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AffiliationPicker, useAffiliations } from "@/components/AffiliationPicker";

export const AffiliationPanel = ({ onApplied }) => {
  const { church, setChurch } = useAuth();
  const d = useAffiliations();
  const [pick, setPick] = useState("");
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);
  const [name, setName] = useState(church?.affiliation_name || "");
  if (church?.role !== "owner") return null;
  const current = church.affiliation ? (church.affiliation === "custom" && church.affiliation_name) || d?.affiliations[church.affiliation] : "Not selected yet";

  const choose = async (k) => {
    setPick(k);
    setPreview((await api.get("/church/affiliation/preview", { params: { affiliation: k } })).data);
  };
  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/church/affiliation", { affiliation: pick, affiliation_name: pick === "custom" ? name : null });
      setChurch(data);
      setPreview(null); setPick("");
      toast.success("Affiliation saved");
      onApplied();
    } catch { toast.error("Could not apply. Please try again."); }
    finally { setBusy(false); }
  };
  const positions = preview?.items.filter((i) => i.kind === "position") || [];

  return (
    <section className="card-soft p-7 mt-8" data-testid="affiliation-panel">
      <p className="font-display text-navy text-lg font-semibold">Ministry library</p>
      <p className="text-sm text-muted-ink mt-1">Current affiliation: <span className="text-navy" data-testid="current-affiliation">{current}</span></p>
      <div className="mt-5"><AffiliationPicker value={pick} onChange={choose} /></div>
      {preview && (
        <div className="bg-paper rounded-xl p-5 mt-5 text-sm" data-testid="affiliation-preview">
          {preview.items.length ? <>
            <p className="text-navy">Adds <b>{preview.new}</b> items: {positions.length} volunteer positions, plus ministries and church offices (offices are never recommended automatically).</p>
            <p className="text-muted-ink mt-2">Positions: {positions.map((p) => p.name).join(", ")}</p>
            {preview.to_hide.length > 0 && <p className="text-muted-ink mt-2">These current teams will be hidden (not deleted): {preview.to_hide.join(", ")}</p>}
            <p className="text-muted-ink mt-2">Your {preview.volunteers} completed assessments keep their original results. Only new assessments use these positions.</p>
          </> : <>
            <p className="text-navy">Saves "Other / Custom". Your current teams stay exactly as they are.</p>
            <input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} placeholder="Your denomination or tradition (optional)"
              className="mt-3 w-full h-11 rounded-lg border border-line px-3 bg-white" data-testid="affiliation-custom-name" />
          </>}
          <button onClick={apply} disabled={busy} className="btn-navy !py-2.5 mt-4" data-testid="affiliation-apply-btn">{busy ? "Applying..." : "Apply"}</button>
        </div>
      )}
    </section>
  );
};
